import React, { PureComponent } from 'react';
import Proptypes from 'prop-types';
import styles from './index.css';

class Banner extends PureComponent {
    static propTypes = {
        type: Proptypes.oneOf(['small', 'large', 'car', 'url']),
        title: Proptypes.string,
        url: Proptypes.string,
        style: Proptypes.object,
    };

    render() {
        const { type, title, style, url } = this.props;

        return (
            <div className={`${styles.banner} ${styles[type]}`} style={style}>
                {title}
                {url && (
                    <a href={url} target="_blank">
                        更多
                    </a>
                )}
            </div>
        );
    }
}

export default Banner;
